import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Constants } from '../../../model/constants';
// import * as $ from '../../../../assets/js/jquery-3.3.1.min.js';
// import '../../../../assets/js/jquery.mkhplayer.js';

@Component({
  selector: 'app-player-video',
  templateUrl: './player-video.component.html',
  styleUrls: ['./player-video.component.css']
})
export class PlayerVideoComponent implements OnInit {

    @Input() servicePath: string;
    @ViewChild('video') video: HTMLVideoElement;
    videoSource: string;
    // videoSourceWebm: string;

    constructor() { }

    ngOnInit() {
        this.videoSource = Constants.MEDIA_ENDPOINT + this.servicePath;
        // this.videoSourceWebm = this.videoSource.substring(0, this.videoSource.lastIndexOf('.')) + '.webm';
        // tslint:disable-next-line: only-arrow-functions
        // $(document).ready(function() {
        //     $('video').mkhPlayer();
        // });
    }

}
